module.exports = __webpack_public_path__ + "static/media/img17.bbc7b755.jpg";